const cartPageStyle = {
    wrapper: `grid gap-[30px] w-full pt-4 container pb-5  wrapper`,
}
export { cartPageStyle };